import axios from "axios";
import Config from "../config";
import { AxiosInstance } from "../helpers/AxiosInstance";
import { WebFormStatus } from "../models/web-form.model";

const createWebForm = (data) => {
    return AxiosInstance.post(`${Config.API_URL}/api/ContactWebForms`, data);
};

const updateWebForm = (data, imageCleared: boolean) => {
    return AxiosInstance.put(`${Config.API_URL}/api/ContactWebForms?imageCleared=${imageCleared}`, data);
};

const deleteWebForm = (id: string) => {
    return AxiosInstance.delete(`${Config.API_URL}/api/ContactWebForms/${id}`);
}

const getAllwebForms = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/ContactWebForms`);
}

const getWebFormByid = (id: string) => {
    return AxiosInstance.get(`${Config.API_URL}/api/ContactWebForms/${id}`);
}

const getWebFormHistoryByid = (id: string) => {
    return AxiosInstance.get(`${Config.API_URL}/api/ContactWebForms/History/${id}`);
}

const getEndUserWebFormByid = (id: string) => {
    return axios.get(`${Config.API_URL}/api/ContactWebForms/public/${id}`);
}

const updateWebformStatus = (id: string, status: WebFormStatus) => {
    return AxiosInstance.patch(`${Config.API_URL}/api/ContactWebForms/${id}/${status}`);
}

const createContact = (id: string, data) => {
    return axios.post(`${Config.API_URL}/api/Contacts/${id}`, data);
}

export const WebFormService = {
    createWebForm,
    updateWebForm,
    deleteWebForm,
    getAllwebForms,
    getWebFormByid,
    getWebFormHistoryByid,
    getEndUserWebFormByid,
    updateWebformStatus,
    createContact,
}